/**
 * Validate executor's assignments before forcing the `transport_distributed` transition.
 * Returns a map of `assignment.uuid → Set<missingFieldName>`. Empty map = all good.
 */
export const validateForTransportDistributed = (
    assignments: any[],
    vn: any,
): Record<string, Set<string>> => {
    const result: Record<string, Set<string>> = {}
    for (const a of assignments) {
        const missing = new Set<string>()
        if (!a.driver) missing.add('driver')
        if (!a.vehicle) missing.add('vehicle')
        if (a.tripsCount == null || a.tripsCount === '') missing.add('tripsCount')
        if (!a.loadingPoint && !vn.loadingPoint) missing.add('loadingPoint')
        if (!a.unloadingPoint && !vn.unloadingPoint) missing.add('unloadingPoint')
        if (missing.size > 0) result[a.uuid] = missing
    }
    return result
}
